import React from 'react';

import  '@/css/loadingDots.scss';

const Loading = ({styleOveride = {}}: {styleOveride?: any} ) => (
    <div className="lds-ellipsis">
        <div style={styleOveride}></div>
        <div style={styleOveride}></div>
        <div style={styleOveride}></div>
        <div style={styleOveride}></div>
    </div>
);

export default Loading;